import { ItemSelector } from "components/panes/ItemSelector";
import { ModalActionsWrapper } from "components/ui/layout";
import { useStore } from "hooks";
import { useNavigate } from "react-router-dom";

export function AccountsPage() {
  const navigate = useNavigate();
  const { profileStore } = useStore();
  const { accounts } = profileStore;

  return (
    <ModalActionsWrapper onCancel={() => navigate(-1)}>
      <ItemSelector
        onChange={(data: any) => {
          navigate(`${data.id}`);
        }}
        items={accounts}
      />
    </ModalActionsWrapper>
  );
}
